module.exports = __webpack_public_path__ + "img/martin1.d9bf2972.jpg";